export enum MessageEvent {
    JOIN = 'JOIN',
    SEEN = 'SEEN',
    DELIVERED= 'DELIVERED',
    RECEIVED = 'RECEIVED',
    SYSTEM = 'SYSTEM'
}
